import { Box, Grid } from "@mui/material";
import BannerView from "./bannerView";
import WebNavigationComponent from "../components/navigation/webNavigationComponent";

const BannerLayout = ({
    navOptionIndex=-1, 
    title, 
    description, 
    children,
    action=null,
    actionText=""
}) => {
    return (
        <>
            {
                navOptionIndex === -1
                ?
                <></>
                :
                <WebNavigationComponent defaultIndex={navOptionIndex} />
            }

            {/* Pc View */}
            <Grid
                xs
                container
                display={{xs: 'none', lg: 'flex'}}
            >
                <Grid xs={12} lg={4}>
                    <BannerView 
                        title={title}
                        description={description}
                        ml={navOptionIndex === -1 ? 0 : 10}
                        action={action}
                        actionText={actionText}
                    />
                </Grid>

                <Grid 
                    xs={12} 
                    lg={8}
                    sx={{
                        width: '100vw',
                    }}
                    ml={{xs: 0, md: '33%'}}
                >
                    <Box
                        ml={navOptionIndex === -1 ? 0 : 10}
                    >
                        {children}
                    </Box>
                </Grid>
            </Grid>

            {/* Tab and Mobile View */}
            <Box
                sx={{
                    width: '100%',
                    display: {xs: 'block', lg: 'none'}
                }}
            >
                {children}
            </Box>
        </>
    );
}

export default BannerLayout;